module.exports = __WEBPACK_EXTERNAL_MODULE_101__;


//////////////////
// WEBPACK FOOTER
// external "vuex"
// module id = 101
// module chunks = 0